import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type ChipTone = "published" | "waiting" | "draft" | "info" | "ok" | "warn" | "err" | "neutral";

interface ChipProps {
  tone: ChipTone;
  /** Leading status dot in the chip's colour. */
  dot?: boolean;
  children: ReactNode;
  className?: string;
}

const TONES: Record<ChipTone, string> = {
  published: "bg-ds-ok-tint text-ds-ok",
  ok: "bg-ds-ok-tint text-ds-ok",
  waiting: "bg-ds-warn-tint text-ds-warn",
  warn: "bg-ds-warn-tint text-ds-warn",
  draft: "bg-ds-sunk text-ds-ink2",
  neutral: "bg-ds-sunk text-ds-ink2",
  info: "bg-ds-info-tint text-ds-accent-ink",
  err: "bg-ds-err-tint text-ds-err",
};

/** Small status label (22 high, 6-px radius) in one of the status tones. */
export function Chip({ tone, dot = false, children, className }: ChipProps) {
  return (
    <span
      data-tone={tone}
      className={cn(
        "inline-flex h-[22px] items-center gap-[5px] whitespace-nowrap rounded-md px-2 font-ds text-xs font-semibold",
        TONES[tone],
        className
      )}
    >
      {dot && <span data-chip-dot="" aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}
